module.exports = "#disabilityModal .modal-header .close {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  font-size: 16px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/internal/accmgr/ba/Disability/disability.component.css
// module id = ./client/app/internal/accmgr/ba/Disability/disability.component.css
// module chunks = main